
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {
    CircularGauge,
    Scale,
    Label,
    RangeContainer,
    Range,
    Export,
    Title,
    Font,
  } from 'devextreme-react/circular-gauge';
import config from 'devextreme/core/config';

export default class OBCircularGauge extends Component {
    
    render() {
        const {setProps} = this.props;
        config({licenseKey: this.props.licenseKey});
        // const dataSource = new PivotGridDataSource(this.props.dataConfig);

        // const scale = {startValue: 0, endValue: 100, tickInterval: 10, labelCustomizeText: 'customizeText' };
        const scaleJSX = (
            <React.Fragment>
                <Scale startValue={this.props.scale.startValue} endValue={this.props.scale.endValue} tickInterval={this.props.scale.tickInterval} />
                <Label customizeText={this.props.scale.labelCustomizeText} />
            </React.Fragment>
        );
        // console.log("Scale JSX: ", scaleJSX);

        
        // const listOfRanges = [{startValue: 0, endValue: 20, color: "#CE2029"}, 
        //                 {startValue: 20, endValue: 50, color: "#FFD700"}, 
        //                 {startValue: 50, endValue: 100, color: "#228B22"}]

        const rangesJSX = this.props.listOfRanges.map((range) => (
                            <Range
                              key={`${range.startValue}-${range.endValue}`}
                              startValue={range.startValue}
                              endValue={range.endValue}
                              color={range.color}
                            />
                          ));

        // console.log("Ranges JSX: ", rangesJSX);
        
        return (
            <React.Fragment>

        <CircularGauge
            id={this.props.id}
            value={this.props.value}
            >
            {scaleJSX}
                
            <RangeContainer>
                {rangesJSX}
            </RangeContainer>

            <Export enabled={true} />

            {/* <Title text="Battery Charge">
                <Font size={28} />
            </Title> */}

            </CircularGauge>

        </React.Fragment>
        );
    }
}

OBCircularGauge.propTypes = {
    id: PropTypes.string,
    value: PropTypes.number,
    licenseKey: PropTypes.string,
    scale: PropTypes.object,
    listOfRanges: PropTypes.array,
    // dataConfig: PropTypes.object.isRequired,
    // height: PropTypes.number,
    // cell: PropTypes.object,

    // Dash supplied props
    setProps: PropTypes.func
};